//Handle back button
function goBack() {
  window.history.back();
}

// Handle size selection
document.addEventListener('DOMContentLoaded', function () {
  var sizeButtons = document.querySelectorAll('.size-option');
  var selectedSizeInput = document.getElementById('selected-size');
  var remainingQuantityInput = document.getElementById('remaining-quantity');
  var addToCartButton = document.getElementById('add-to-cart');
  var quantityInput = document.getElementById('quantity');

  // Safety check - ensure inputs exist
  if (!selectedSizeInput || !remainingQuantityInput) {
    console.error('Required input elements not found');
    return;
  }

  // Check if product has no size variants (magazine, single variant products)
  var productData =
    typeof window.productData !== 'undefined' ? window.productData : null;
  var hasSizeVariants = sizeButtons.length > 0;

  // If no size variants (e.g., magazines) and inputs are empty, auto-select the only variant
  if (
    !hasSizeVariants &&
    !selectedSizeInput.value &&
    productData &&
    productData.variants &&
    productData.variants.length === 1
  ) {
    var singleVariant = productData.variants[0];
    selectedSizeInput.value = singleVariant.id;
    remainingQuantityInput.value = singleVariant.inventory_quantity;
    console.log('Auto-selected single variant:', singleVariant.id);
  }

  // Iterate through size buttons
  sizeButtons.forEach(function (button) {
    var variantId = button.getAttribute('data-variant-id');
    var variant = getVariantById(variantId);
    var remainingQuantity = button.getAttribute('data-quantity');

    // console.log("Variant id: ", variantId);
    // console.log("Availability: ", variant.available);
    // console.log("Remaining Quantity: ", remainingQuantity);
    //console.log("Variant json: ", variant);

    // Check if the variant is available
    if (variant && !variant.available) {
      // Disable the button and change its font color
      button.setAttribute('disabled', true);
      button.setAttribute('data-tooltip-text', 'Sold Out');
      button.classList.add('tooltip');
      button.style.color = 'rgba(0,0,0,0.3)';
    }

    // Add click event for the variant button
    button.addEventListener('click', function () {
      if (variant && variant.available) {
        // Remove 'size-option-active' class from all buttons
        sizeButtons.forEach(function (btn) {
          btn.classList.remove('size-option-active');
        });

        // Add 'size-option-active' class to the clicked button
        this.classList.add('size-option-active');

        // Set the selected size and remaining quantity in the hidden input
        selectedSizeInput.value = variantId;
        remainingQuantityInput.value = remainingQuantity;
        console.log(
          'Remaining quantity input value: ',
          remainingQuantityInput.value,
        );
      }
    });
  });
});

// Quantity adjustments for cart
function decreaseQuantity() {
  var quantityInput = document.getElementById('quantity');
  var currentQuantity = parseInt(quantityInput.value) || 1;

  if (currentQuantity > 1) {
    quantityInput.value = currentQuantity - 1;
  }
}

function increaseQuantity() {
  var quantityInput = document.getElementById('quantity');
  var currentQuantity = parseInt(quantityInput.value) || 1;

  quantityInput.value = currentQuantity + 1;
}

function reset() {
  var sizeButtons = document.querySelectorAll('.size-option');
  var selectedSizeInput = document.getElementById('selected-size');
  var remainingQuantityInput = document.getElementById('remaining-quantity');
  var quantityInput = document.getElementById('quantity');

  sizeButtons.forEach(function (button) {
    button.classList.remove('size-option-active');
  });

  selectedSizeInput.value = '';
  remainingQuantityInput.value = '';
  quantityInput.value = 1;
}

// Function to get Cart
async function getCart() {
  const res = await fetch('cart.json');
  const cart = await res;
  return cart;
}

// Check if stock quantity is sufficient
function sufficientQuantity(quantity, remainingQuantity) {
  return remainingQuantity >= quantity;
}

// Handle cart button
$(document).ready(function () {
  // Cart click event
  $('#add-to-cart').on('click', function () {
    // Prevent the default form submission behavior
    event.preventDefault();

    var addToCartButton = document.getElementById('add-to-cart');
    var selectedSizeInput = document.getElementById('selected-size');
    var quantityInput = document.getElementById('quantity');
    var remainingQuantityInput = document.getElementById('remaining-quantity');
    var productNotification = document.getElementById('product-notification');

    var selectedVariantId = selectedSizeInput.value;
    var quantity = parseInt(quantityInput.value);
    var remainingQuantity = parseInt(remainingQuantityInput.value);
    var isSufficient = sufficientQuantity(quantity, remainingQuantity);

    if (selectedVariantId && isSufficient) {
      // Disable button and show loading state
      addToCartButton.disabled = true;
      var originalText = addToCartButton.textContent;
      addToCartButton.textContent = 'Adding...';
      addToCartButton.style.opacity = '0.6';
      addToCartButton.style.cursor = 'not-allowed';

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: quantity,
          id: selectedVariantId,
        },
        dataType: 'json',
        success: function (response) {
          // Handle the response
          console.log('Product added to cart:', response);

          // Re-enable button
          addToCartButton.disabled = false;
          addToCartButton.textContent = originalText;
          addToCartButton.style.opacity = '1';
          addToCartButton.style.cursor = 'pointer';

          // You can customize this part to show a success message, update the cart icon, etc.
          productNotification.textContent =
            'Product added to cart \n Check bag to view cart contents';
          productNotification.style.display = 'block';
          productNotification.style.opacity = 1;
          // alert("Product added to cart!");

          // Hide the message after 3 seconds
          setTimeout(() => {
            productNotification.style.opacity = 0;
            setTimeout(() => {
              productNotification.style.display = 'none';
            }, 1000); // Hide after fade out animation (assuming it's 1 second)
          }, 3000); // 3 seconds delay

          //Update cart drawer (function resides in lm-cart.js)
          updateCartDrawer();

          // Clear the selected variant and quantity inputs
          reset();
        },
        error: function (error) {
          console.error('Error adding item to cart:', error);

          // Re-enable button on error
          addToCartButton.disabled = false;
          addToCartButton.textContent = originalText;
          addToCartButton.style.opacity = '1';
          addToCartButton.style.cursor = 'pointer';

          // Handle errors, e.g., display an error message
          productNotification.textContent = error.responseJSON.description;
          productNotification.style.display = 'block';
          productNotification.style.opacity = 1;

          // Hide the message after 3 seconds
          setTimeout(() => {
            productNotification.style.opacity = 0;
            setTimeout(() => {
              productNotification.style.display = 'none';
            }, 1000); // Hide after fade out animation (assuming it's 1 second)
          }, 3000); // 3 seconds delay
        },
      });
    } else if (!selectedVariantId) {
      // Handle the case where a variant is not selected
      // Check if product has size variants
      var hasSizeVariants =
        document.querySelectorAll('.size-option').length > 0;
      var message = hasSizeVariants
        ? 'Please select a size before adding to cart'
        : 'Unable to add product to cart. Please try again.';

      productNotification.textContent = message;
      productNotification.style.display = 'block';
      productNotification.style.opacity = 1;

      // Hide the message after 3 seconds
      setTimeout(() => {
        productNotification.style.opacity = 0;
        setTimeout(() => {
          productNotification.style.display = 'none';
        }, 1000); // Hide after fade out animation (assuming it's 1 second)
      }, 3000); // 3 seconds delay
    } else if (!isSufficient) {
      // Handle the case where the remaining quantity of a variant is not sufficient
      productNotification.textContent = `Quantity not available. \n Available Quantity: ${remainingQuantityInput.value}`;
      productNotification.style.display = 'block';
      productNotification.style.opacity = 1;

      // Hide the message after 3 seconds
      setTimeout(() => {
        productNotification.style.opacity = 0;
        setTimeout(() => {
          productNotification.style.display = 'none';
        }, 1000); // Hide after fade out animation (assuming it's 1 second)
      }, 3000); // 3 seconds delay
    }
    //const cart = await getCart();
    //await updateCartDisplay(cart);
  });

  // Get fresh
});
